import React, { useState, useContext, useRef } from 'react';
import { AuthContext } from '../context/AuthContext';
import '../styles/sms.css';
import { useNavigate } from 'react-router-dom';
import Account from '../components/Account';

const BulkSms = () => {
  const { sendBulkSms, fetchNotifications } = useContext(AuthContext);

  const [message, setMessage] = useState('');
  const [sendto, setSendto] = useState('');
  const [sender, setSender] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const senderRef = useRef(null);
  const sendtoRef = useRef(null);
  const messageRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!sender) {
      newErrors.sender = "Sender ID is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(sender)) {
      newErrors.sender = "Sender ID must contain only letters.";
    }

    if (!sendto) {
      newErrors.sendto = "Please enter recipient numbers.";
    } else {
      const recipients = sendto.split(',').map(num => num.trim());
      const invalidNumbers = recipients.filter(num => !/^\d{11}$/.test(num));
      if (invalidNumbers.length > 0) {
        newErrors.sendto = "Each number must be exactly 11 digits.";
      }
    }

    if (!message) {
      newErrors.message = "Message cannot be empty.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      // Scroll to first error
      if (newErrors.sender) senderRef.current.scrollIntoView({ behavior: 'smooth' });
      else if (newErrors.sendto) sendtoRef.current.scrollIntoView({ behavior: 'smooth' });
      else if (newErrors.message) messageRef.current.scrollIntoView({ behavior: 'smooth' });

      return;
    }

    // Clear errors
    setErrors({});

    const recipients = sendto.split(',').map(num => num.trim());
    const recipientCount = recipients.length;
    const commissionPerRecipient = 10;
    const totalCost = recipientCount * commissionPerRecipient;

    navigate('/review', {
      state: {
        type: 'bulksms',
        details: {
          message,
          sendto,
          sender,
          totalCost
        }
      }
    });
  };

  return (
    <div>
      <Account />
      <div className="bulk-container">
        <div className="bulk-card">
          <form className="bulk-form" onSubmit={handleSubmit}>

            <div className="bulk-row" ref={senderRef}>
              <label>Sender ID</label>
              <input
                className="styled-input"
                type="text"
                value={sender}
                onChange={(e) => setSender(e.target.value)}
                placeholder="e.g. John Snow"
              />
              {errors.sender && <p className="error-input">{errors.sender}</p>}
            </div>

            <div className="bulk-row" ref={sendtoRef}>
              <label>Recipient Numbers</label>
              <textarea
                className="styled-input"
                value={sendto}
                onChange={(e) => setSendto(e.target.value)}
                placeholder="e.g. 08012345678, 08123456789"
                rows="3"
              />
              {errors.sendto && <p className="error-input">{errors.sendto}</p>}
            </div>

            <div className="bulk-row" ref={messageRef}>
              <label>Message</label>
              <textarea
                className="styled-input"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message..."
                rows="5"
              />
              {errors.message && <p className="error-input">{errors.message}</p>}
            </div>

            <button type="submit" className="bulk-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BulkSms;
